import { useSearchParams } from "react-router-dom";

export function BereichSeite({ titel, untertitel, icon: Icon, tabs, defaultTab, badge }) {
  const [params, setParams] = useSearchParams();
  const aktiv = tabs.find((t) => t.key === params.get("tab"))?.key || defaultTab || tabs[0].key;
  const tab = tabs.find((t) => t.key === aktiv);
  return (
    <div data-testid={`bereich-${titel.toLowerCase().replace(/[^a-z]/g, "")}`}>
      <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-4">
        {Icon && <div className="h-8 w-8 sm:h-11 sm:w-11 rounded-lg sm:rounded-xl bg-slate-900 text-white flex items-center justify-center shrink-0"><Icon className="h-4 w-4 sm:h-5 sm:w-5" /></div>}
        <div className="min-w-0">
          <h1 className="font-['Manrope'] text-lg sm:text-2xl font-bold text-slate-900 flex items-center gap-2 leading-tight">{titel}{badge}<span className="sm:hidden text-slate-400 font-normal text-sm">› {tab?.kurz || tab?.label}</span></h1>
          {untertitel && <p className="hidden sm:block text-sm text-slate-500">{untertitel}</p>}
        </div>
      </div>
      <div className="-mx-4 px-4 sm:mx-0 sm:px-0 flex sm:flex-wrap gap-1 pb-2 mb-3 sm:mb-5 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="tablist">
        {tabs.map((t) => (
          <button key={t.key} role="tab" aria-selected={aktiv === t.key} onClick={() => setParams({ tab: t.key })} data-testid={`tab-${t.key}`}
            className={`h-9 sm:h-10 px-3 sm:px-4 rounded-full sm:rounded-xl text-sm font-semibold whitespace-nowrap shrink-0 inline-flex items-center gap-2 transition-colors ${aktiv === t.key ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
            <span className="sm:hidden">{t.kurz || t.label}</span><span className="hidden sm:inline">{t.label}</span>{t.count != null && t.count > 0 && <span className={`text-xs px-1.5 rounded-full ${aktiv === t.key ? "bg-white/20" : "bg-amber-100 text-amber-800"}`}>{t.count}</span>}
          </button>
        ))}
      </div>
      <div className="[&_h1]:text-lg [&_h1]:mb-2" data-testid={`panel-${aktiv}`}>{tab?.render()}</div>
    </div>
  );
}
